import React from 'react';

const Portals = () => {
  return <div></div>;
};

export default Portals;
